export default __webpack_public_path__ + "static/media/155.a635c9b9.png";